import React from 'react'
import { Fab } from '@mui/material'
import PrintIcon from '@mui/icons-material/Print'

const PDFPrinter = ({ file }) => {
  const print = () => {
    const pdfFrame = document.createElement('iframe')
    pdfFrame.style.visibility = 'hidden'
    pdfFrame.style.position = 'fixed'
    pdfFrame.style.right = '0'
    pdfFrame.style.bottom = '0'
    pdfFrame.src = file

    document.body.appendChild(pdfFrame)

    pdfFrame.onload = () => {
      try {
        pdfFrame.contentWindow.focus()
        pdfFrame.contentWindow.print()
      } catch (error) {
        alert('Printing failed. Please try downloading the file and printing manually.')
      } finally {
        setTimeout(() => {
          document.body.removeChild(pdfFrame)
        }, 1000)
      }
    }
  }

  return (
    <Fab sx={{ mx: 1 }} size='small' color='primary' aria-label='print' onClick={print}>
      <PrintIcon />
    </Fab>
  )
}

export default PDFPrinter
